import * as React from 'react';
import classnames from 'classnames';

import './form-actions.scss';

type Props = {
  children: React.ReactNode,
  containerClass: string,
  align: 'left' | 'center' | 'spread'
};

class FormActions extends React.PureComponent<Props> {
  static defaultProps = {
    align: 'left',
    containerClass: ''
  };

  render(): React.ReactNode {
    const { children, align, containerClass } = this.props;

    const actionsClasses = classnames({
      'form-actions': true,
      [`form-actions--align-${align}`]: align,
      [containerClass]: true
    });

    return (
      <div className={actionsClasses}>
        {children}
      </div>
    );
  }
}

export default FormActions;
